import { Component, Input } from '@angular/core';
import { DonutComponent } from "../../charts/donut/donut.component";
import { BarComponent } from "../../charts/bar/bar.component";

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [DonutComponent, BarComponent],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.scss'
})
export class StatisticsComponent {

  @Input() questionCode: string | undefined;

  constructor(){}

}
